// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dDate from "../Data.Date/index.js";
import * as Data$dEnum$dGeneric from "../Data.Enum.Generic/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dOrdering from "../Data.Ordering/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dGeneric$dEnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dCalendar$dTypes$dRestaurantLocalDay from "../Restaumatic.Calendar.Types.RestaurantLocalDay/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble$dEnum from "../Unscramble.Enum/index.js";
const $CouponSource = tag => ({tag});
const eq1 = /* #__PURE__ */ Data$dEq.eqArrayImpl(Data$dEq.eqIntImpl);
const eq5 = x => y => {
  if (x.tag === "Nothing") { return y.tag === "Nothing"; }
  if (x.tag === "Just") {
    if (y.tag === "Just") { return Data$dDate.eqDate.eq(x._1)(y._1); }
    return false;
  }
  return false;
};
const ManualIsSymbol = {reflectSymbol: () => "Manual"};
const FirstOrderDiscountIsSymbol = {reflectSymbol: () => "FirstOrderDiscount"};
const LoyaltyIsSymbol = {reflectSymbol: () => "Loyalty"};
const PbxIsSymbol = {reflectSymbol: () => "Pbx"};
const FirstAbsenceReminderIsSymbol = {reflectSymbol: () => "FirstAbsenceReminder"};
const SecondAbsenceReminderIsSymbol = {reflectSymbol: () => "SecondAbsenceReminder"};
const RosPhoneOrderIsSymbol = {reflectSymbol: () => "RosPhoneOrder"};
const RosPortalOrderIsSymbol = {reflectSymbol: () => "RosPortalOrder"};
const promotionIdIsSymbol = {reflectSymbol: () => "promotionId"};
const sourceIsSymbol = {reflectSymbol: () => "source"};
const PromotionIdForSourceIsSymbol = {reflectSymbol: () => "PromotionIdForSource"};
const activeCouponsIsSymbol = {reflectSymbol: () => "activeCoupons"};
const generatedCouponsIsSymbol = {reflectSymbol: () => "generatedCoupons"};
const marketingIsSymbol = {reflectSymbol: () => "marketing"};
const usedCouponsIsSymbol = {reflectSymbol: () => "usedCoupons"};
const UsageDataIsSymbol = {reflectSymbol: () => "UsageData"};
const genericTopConstructor = {"genericTop'": Data$dGeneric$dRep.NoArguments};
const genericBottomConstructor = {"genericBottom'": Data$dGeneric$dRep.NoArguments};
const genericBottomSum = {"genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)};
const genericEnumConstructor = /* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments);
const genericEnumSum = /* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(genericEnumConstructor)(genericTopConstructor);
const genericEnumSum1 = /* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(genericEnumConstructor)(genericBottomConstructor))(genericBottomSum))(genericBottomSum))(genericBottomSum))(genericBottomSum))(genericBottomSum))(genericBottomSum);
const genericBoundedEnumConstructor = /* #__PURE__ */ Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments);
const genericBoundedEnumSum = /* #__PURE__ */ Data$dEnum$dGeneric.genericBoundedEnumSum(genericBoundedEnumConstructor);
const genericBoundedEnumSum1 = /* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(genericBoundedEnumConstructor)))))));
const codeIsSymbol = {reflectSymbol: () => "code"};
const expiresOnIsSymbol = {reflectSymbol: () => "expiresOn"};
const promotionNameIsSymbol = {reflectSymbol: () => "promotionName"};
const CouponInfoIsSymbol = {reflectSymbol: () => "CouponInfo"};
const encodeWithOptionsOther = {encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce};
const encodeWithOptionsOther1 = {encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce};
const decodeWithOptionsOther = {decodeWithOptions: v => Foreign$dGeneric$dClass.intDecode.decode};
const decodeWithOptionsOther1 = {decodeWithOptions: v => Foreign$dGeneric$dClass.readString};
const Manual = /* #__PURE__ */ $CouponSource("Manual");
const FirstOrderDiscount = /* #__PURE__ */ $CouponSource("FirstOrderDiscount");
const Loyalty = /* #__PURE__ */ $CouponSource("Loyalty");
const Pbx = /* #__PURE__ */ $CouponSource("Pbx");
const FirstAbsenceReminder = /* #__PURE__ */ $CouponSource("FirstAbsenceReminder");
const SecondAbsenceReminder = /* #__PURE__ */ $CouponSource("SecondAbsenceReminder");
const RosPhoneOrder = /* #__PURE__ */ $CouponSource("RosPhoneOrder");
const RosPortalOrder = /* #__PURE__ */ $CouponSource("RosPortalOrder");
const PromotionIdForSource = x => x;
const UsageData = x => x;
const CouponInfo = x => x;
const newtypeUsageData_ = {Coercible0: () => {}};
const newtypePromotionIdForSour = {Coercible0: () => {}};
const newtypeCouponInfo_ = {Coercible0: () => {}};
const hasFieldUsageData = dictHasField => dictHasField;
const hasFieldPromotionIdForSou = dictHasField => dictHasField;
const hasFieldCouponInfo = dictHasField => dictHasField;
const eqCouponSource = {
  eq: x => y => {
    if (x.tag === "Manual") { return y.tag === "Manual"; }
    if (x.tag === "FirstOrderDiscount") { return y.tag === "FirstOrderDiscount"; }
    if (x.tag === "Loyalty") { return y.tag === "Loyalty"; }
    if (x.tag === "Pbx") { return y.tag === "Pbx"; }
    if (x.tag === "FirstAbsenceReminder") { return y.tag === "FirstAbsenceReminder"; }
    if (x.tag === "SecondAbsenceReminder") { return y.tag === "SecondAbsenceReminder"; }
    if (x.tag === "RosPhoneOrder") { return y.tag === "RosPhoneOrder"; }
    if (x.tag === "RosPortalOrder") { return y.tag === "RosPortalOrder"; }
    return false;
  }
};
const eq7 = /* #__PURE__ */ (() => Data$dEq.eqArrayImpl(eqCouponSource.eq))();
const eqPromotionIdForSource = {
  eq: x => y => (() => {
    if (x.promotionId.tag === "Nothing") { return y.promotionId.tag === "Nothing"; }
    if (x.promotionId.tag === "Just") {
      if (y.promotionId.tag === "Just") { return x.promotionId._1 === y.promotionId._1; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.source.tag === "Manual") { return y.source.tag === "Manual"; }
    if (x.source.tag === "FirstOrderDiscount") { return y.source.tag === "FirstOrderDiscount"; }
    if (x.source.tag === "Loyalty") { return y.source.tag === "Loyalty"; }
    if (x.source.tag === "Pbx") { return y.source.tag === "Pbx"; }
    if (x.source.tag === "FirstAbsenceReminder") { return y.source.tag === "FirstAbsenceReminder"; }
    if (x.source.tag === "SecondAbsenceReminder") { return y.source.tag === "SecondAbsenceReminder"; }
    if (x.source.tag === "RosPhoneOrder") { return y.source.tag === "RosPhoneOrder"; }
    if (x.source.tag === "RosPortalOrder") { return y.source.tag === "RosPortalOrder"; }
    return false;
  })()
};
const eqUsageData = {
  eq: x => y => eq1(x.activeCoupons)(y.activeCoupons) && x.generatedCoupons === y.generatedCoupons && eq7(x.marketing)(y.marketing) && x.promotionId === y.promotionId && x.usedCoupons === y.usedCoupons
};
const ordCouponSource = {
  compare: x => y => {
    if (x.tag === "Manual") {
      if (y.tag === "Manual") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "Manual") { return Data$dOrdering.GT; }
    if (x.tag === "FirstOrderDiscount") {
      if (y.tag === "FirstOrderDiscount") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "FirstOrderDiscount") { return Data$dOrdering.GT; }
    if (x.tag === "Loyalty") {
      if (y.tag === "Loyalty") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "Loyalty") { return Data$dOrdering.GT; }
    if (x.tag === "Pbx") {
      if (y.tag === "Pbx") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "Pbx") { return Data$dOrdering.GT; }
    if (x.tag === "FirstAbsenceReminder") {
      if (y.tag === "FirstAbsenceReminder") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "FirstAbsenceReminder") { return Data$dOrdering.GT; }
    if (x.tag === "SecondAbsenceReminder") {
      if (y.tag === "SecondAbsenceReminder") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "SecondAbsenceReminder") { return Data$dOrdering.GT; }
    if (x.tag === "RosPhoneOrder") {
      if (y.tag === "RosPhoneOrder") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "RosPhoneOrder") { return Data$dOrdering.GT; }
    if (x.tag === "RosPortalOrder") {
      if (y.tag === "RosPortalOrder") { return Data$dOrdering.EQ; }
      $runtime.fail();
    }
    $runtime.fail();
  },
  Eq0: () => eqCouponSource
};
const eqCouponInfo = {eq: x => y => x.code === y.code && eq5(x.expiresOn)(y.expiresOn) && x.promotionName === y.promotionName};
const genericUsageData = {to: x => x, from: x => x};
const genericPromotionIdForSource = {to: x => x, from: x => x};
const genericCouponSource = {
  to: x => {
    if (x.tag === "Inl") { return Manual; }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return FirstOrderDiscount; }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return Loyalty; }
        if (x._1._1.tag === "Inr") {
          if (x._1._1._1.tag === "Inl") { return Pbx; }
          if (x._1._1._1.tag === "Inr") {
            if (x._1._1._1._1.tag === "Inl") { return FirstAbsenceReminder; }
            if (x._1._1._1._1.tag === "Inr") {
              if (x._1._1._1._1._1.tag === "Inl") { return SecondAbsenceReminder; }
              if (x._1._1._1._1._1.tag === "Inr") {
                if (x._1._1._1._1._1._1.tag === "Inl") { return RosPhoneOrder; }
                if (x._1._1._1._1._1._1.tag === "Inr") { return RosPortalOrder; }
                $runtime.fail();
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "Manual") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "FirstOrderDiscount") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)); }
    if (x.tag === "Loyalty") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))); }
    if (x.tag === "Pbx") {
      return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))));
    }
    if (x.tag === "FirstAbsenceReminder") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
      );
    }
    if (x.tag === "SecondAbsenceReminder") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
        )
      );
    }
    if (x.tag === "RosPhoneOrder") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
          )
        )
      );
    }
    if (x.tag === "RosPortalOrder") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments))))
          )
        )
      );
    }
    $runtime.fail();
  }
};
const showCouponSource = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(ManualIsSymbol);
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(FirstOrderDiscountIsSymbol);
    const $2 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(LoyaltyIsSymbol);
    const $3 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(PbxIsSymbol);
    const $4 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(FirstAbsenceReminderIsSymbol);
    const $5 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(SecondAbsenceReminderIsSymbol);
    const $6 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(RosPhoneOrderIsSymbol);
    const $7 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(RosPortalOrderIsSymbol);
    return x => {
      const $8 = genericCouponSource.from(x);
      if ($8.tag === "Inl") { return $0["genericShow'"]($8._1); }
      if ($8.tag === "Inr") {
        if ($8._1.tag === "Inl") { return $1["genericShow'"]($8._1._1); }
        if ($8._1.tag === "Inr") {
          if ($8._1._1.tag === "Inl") { return $2["genericShow'"]($8._1._1._1); }
          if ($8._1._1.tag === "Inr") {
            if ($8._1._1._1.tag === "Inl") { return $3["genericShow'"]($8._1._1._1._1); }
            if ($8._1._1._1.tag === "Inr") {
              if ($8._1._1._1._1.tag === "Inl") { return $4["genericShow'"]($8._1._1._1._1._1); }
              if ($8._1._1._1._1.tag === "Inr") {
                if ($8._1._1._1._1._1.tag === "Inl") { return $5["genericShow'"]($8._1._1._1._1._1._1); }
                if ($8._1._1._1._1._1.tag === "Inr") {
                  if ($8._1._1._1._1._1._1.tag === "Inl") { return $6["genericShow'"]($8._1._1._1._1._1._1._1); }
                  if ($8._1._1._1._1._1._1.tag === "Inr") { return $7["genericShow'"]($8._1._1._1._1._1._1._1); }
                  $runtime.fail();
                }
                $runtime.fail();
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const showPromotionIdForSource = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        "{ promotionId: " + (() => {
          if (v.promotionId.tag === "Just") { return "(Just " + Data$dShow.showIntImpl(v.promotionId._1) + ")"; }
          if (v.promotionId.tag === "Nothing") { return "Nothing"; }
          $runtime.fail();
        })() + ", source: " + showCouponSource.show(v.source) + " " + "}"
      ]
    })(PromotionIdForSourceIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const showUsageData = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dShow.showArrayImpl(showCouponSource.show);
      const $1 = Data$dShow.showArrayImpl(Data$dShow.showIntImpl);
      return {
        genericShowArgs: v => [
          "{ activeCoupons: " + $1(v.activeCoupons) + ", generatedCoupons: " + Data$dShow.showIntImpl(v.generatedCoupons) + ", marketing: " + $0(v.marketing) + ", promotionId: " + Data$dShow.showIntImpl(v.promotionId) + ", usedCoupons: " + Data$dShow.showIntImpl(v.usedCoupons) + " " + "}"
        ]
      };
    })())(UsageDataIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeCouponSource = {
  unsafeDecode: /* #__PURE__ */ Unscramble$dEnum.genericUnsafeDecodeEnum(genericCouponSource)(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("Manual"), Data$dGeneric$dRep.NoArguments)]
  })(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("FirstOrderDiscount"), Data$dGeneric$dRep.NoArguments)]
  })(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("Loyalty"), Data$dGeneric$dRep.NoArguments)]})(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("Pbx"), Data$dGeneric$dRep.NoArguments)]
  })(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("FirstAbsenceReminder"), Data$dGeneric$dRep.NoArguments)]
  })(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("SecondAbsenceReminder"), Data$dGeneric$dRep.NoArguments)]
  })(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("RosPhoneOrder"), Data$dGeneric$dRep.NoArguments)]
  })({enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("RosPortalOrder"), Data$dGeneric$dRep.NoArguments)]}))))))))(Unscramble$dEnum.defaultEnumOptions)
};
const unscrambleDecodePromotionIdForSource = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(promotionIdIsSymbol)(Unscramble.decodeMaybe(Unscramble.decodeInt1))(Unscramble.decodeRecordCons(sourceIsSymbol)(unscrambleDecodeCouponSource)(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
  }
))();
const unscrambleDecodeUsageData = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(activeCouponsIsSymbol)({unsafeDecode: Unscramble.decodeArray(Unscramble.decodeInt)})(Unscramble.decodeRecordCons(generatedCouponsIsSymbol)(Unscramble.decodeInt1)(Unscramble.decodeRecordCons(marketingIsSymbol)({
      unsafeDecode: Unscramble.decodeArray(unscrambleDecodeCouponSource.unsafeDecode)
    })(Unscramble.decodeRecordCons(promotionIdIsSymbol)(Unscramble.decodeInt1)(Unscramble.decodeRecordCons(usedCouponsIsSymbol)(Unscramble.decodeInt1)(Unscramble.decodeRecordNil))))).recordInfo(Type$dProxy.Proxy))
  }
))();
const boundedCouponSource = /* #__PURE__ */ (() => (
  {
    top: genericCouponSource.to(Data$dGeneric$dRep.$Sum(
      "Inr",
      Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments))))
        )
      )
    )),
    bottom: genericCouponSource.to(Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)),
    Ord0: () => ordCouponSource
  }
))();
const enumCouponSource = {
  succ: /* #__PURE__ */ Data$dEnum$dGeneric.genericSucc(genericCouponSource)(genericEnumSum1),
  pred: /* #__PURE__ */ Data$dEnum$dGeneric.genericPred(genericCouponSource)(genericEnumSum1),
  Ord0: () => ordCouponSource
};
const boundedEnumCouponSource = /* #__PURE__ */ (() => (
  {
    cardinality: genericBoundedEnumSum1["genericCardinality'"],
    toEnum: Data$dEnum$dGeneric.genericToEnum(genericCouponSource)(genericBoundedEnumSum1),
    fromEnum: x => genericBoundedEnumSum1["genericFromEnum'"](genericCouponSource.from(x)),
    Bounded0: () => boundedCouponSource,
    Enum1: () => enumCouponSource
  }
))();
const genericCouponInfo = {to: x => x, from: x => x};
const showCouponInfo = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        "{ code: " + Data$dShow.showStringImpl(v.code) + ", expiresOn: " + (() => {
          if (v.expiresOn.tag === "Just") { return "(Just " + Restaumatic$dCalendar$dTypes$dRestaurantLocalDay.showRestaurantLocalDay.show(v.expiresOn._1) + ")"; }
          if (v.expiresOn.tag === "Nothing") { return "Nothing"; }
          $runtime.fail();
        })() + ", promotionName: " + Data$dShow.showStringImpl(v.promotionName) + " " + "}"
      ]
    })(CouponInfoIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeCouponInfo = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(codeIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordCons(expiresOnIsSymbol)(Unscramble.decodeMaybe(Restaumatic$dCalendar$dTypes$dRestaurantLocalDay.unscrambleDecodeRestaurantLocalDay))(Unscramble.decodeRecordCons(promotionNameIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordNil))).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodeCouponSource = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEnumEncode(genericCouponSource)({
    encodeEnum: v => v1 => {
      if (v1.tag === "Inl") { return v.constructorTagTransform("Manual"); }
      if (v1.tag === "Inr") {
        if (v1._1.tag === "Inl") { return v.constructorTagTransform("FirstOrderDiscount"); }
        if (v1._1.tag === "Inr") {
          if (v1._1._1.tag === "Inl") { return v.constructorTagTransform("Loyalty"); }
          if (v1._1._1.tag === "Inr") {
            if (v1._1._1._1.tag === "Inl") { return v.constructorTagTransform("Pbx"); }
            if (v1._1._1._1.tag === "Inr") {
              if (v1._1._1._1._1.tag === "Inl") { return v.constructorTagTransform("FirstAbsenceReminder"); }
              if (v1._1._1._1._1.tag === "Inr") {
                if (v1._1._1._1._1._1.tag === "Inl") { return v.constructorTagTransform("SecondAbsenceReminder"); }
                if (v1._1._1._1._1._1.tag === "Inr") {
                  if (v1._1._1._1._1._1._1.tag === "Inl") { return v.constructorTagTransform("RosPhoneOrder"); }
                  if (v1._1._1._1._1._1._1.tag === "Inr") { return v.constructorTagTransform("RosPortalOrder"); }
                  $runtime.fail();
                }
                $runtime.fail();
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    }
  })
};
const encodePromotionIdForSource = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericPromotionIdForSource)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(PromotionIdForSourceIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(sourceIsSymbol)({
      encodeWithOptions: v => encodeCouponSource.encode
    }))(promotionIdIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    });
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeUsageData = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericUsageData)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(UsageDataIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(usedCouponsIsSymbol)(encodeWithOptionsOther))(promotionIdIsSymbol)({
      encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce
    }))(marketingIsSymbol)((() => {
      const encode1 = Data$dFunctor.arrayMap(encodeCouponSource.encode);
      return {encodeWithOptions: v => encode1};
    })()))(generatedCouponsIsSymbol)(encodeWithOptionsOther))(activeCouponsIsSymbol)((() => {
      const encode1 = Data$dFunctor.arrayMap(Unsafe$dCoerce.unsafeCoerce);
      return {encodeWithOptions: v => encode1};
    })());
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeCouponInfo = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericCouponInfo)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(CouponInfoIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(promotionNameIsSymbol)(encodeWithOptionsOther1))(expiresOnIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dCalendar$dTypes$dRestaurantLocalDay.encodeRestaurantLocalDay.encode(v2._1); }
        $runtime.fail();
      }
    }))(codeIsSymbol)(encodeWithOptionsOther1);
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeCouponSource = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultEnumDecode(genericCouponSource)(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(ManualIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(FirstOrderDiscountIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(LoyaltyIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(PbxIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(FirstAbsenceReminderIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(SecondAbsenceReminderIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(RosPhoneOrderIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(RosPortalOrderIsSymbol)))))))))
};
const decodePromotionIdForSource = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericPromotionIdForSource)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(PromotionIdForSourceIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(sourceIsSymbol)({
    decodeWithOptions: v => decodeCouponSource.decode
  })())(promotionIdIsSymbol)({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign$dGeneric$dClass.intDecode.decode)})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeUsageData = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericUsageData)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(UsageDataIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(usedCouponsIsSymbol)(decodeWithOptionsOther)())(promotionIdIsSymbol)({
    decodeWithOptions: v => Foreign$dGeneric$dClass.intDecode.decode
  })())(marketingIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Foreign$dGeneric$dClass.arrayDecode(decodeCouponSource).decode;
    return {decodeWithOptions: v => decode2};
  })())())(generatedCouponsIsSymbol)(decodeWithOptionsOther)())(activeCouponsIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Foreign$dGeneric$dClass.arrayDecode(Foreign$dGeneric$dClass.intDecode).decode;
    return {decodeWithOptions: v => decode2};
  })())())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeCouponInfo = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericCouponInfo)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(CouponInfoIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(promotionNameIsSymbol)(decodeWithOptionsOther1)())(expiresOnIsSymbol)({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dCalendar$dTypes$dRestaurantLocalDay.decodeRestaurantLocalDay.decode)
  })())(codeIsSymbol)(decodeWithOptionsOther1)())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  $CouponSource,
  CouponInfo,
  CouponInfoIsSymbol,
  FirstAbsenceReminder,
  FirstAbsenceReminderIsSymbol,
  FirstOrderDiscount,
  FirstOrderDiscountIsSymbol,
  Loyalty,
  LoyaltyIsSymbol,
  Manual,
  ManualIsSymbol,
  Pbx,
  PbxIsSymbol,
  PromotionIdForSource,
  PromotionIdForSourceIsSymbol,
  RosPhoneOrder,
  RosPhoneOrderIsSymbol,
  RosPortalOrder,
  RosPortalOrderIsSymbol,
  SecondAbsenceReminder,
  SecondAbsenceReminderIsSymbol,
  UsageData,
  UsageDataIsSymbol,
  activeCouponsIsSymbol,
  boundedCouponSource,
  boundedEnumCouponSource,
  codeIsSymbol,
  decodeCouponInfo,
  decodeCouponSource,
  decodePromotionIdForSource,
  decodeUsageData,
  decodeWithOptionsOther,
  decodeWithOptionsOther1,
  encodeCouponInfo,
  encodeCouponSource,
  encodePromotionIdForSource,
  encodeUsageData,
  encodeWithOptionsOther,
  encodeWithOptionsOther1,
  enumCouponSource,
  eq1,
  eq5,
  eq7,
  eqCouponInfo,
  eqCouponSource,
  eqPromotionIdForSource,
  eqUsageData,
  expiresOnIsSymbol,
  generatedCouponsIsSymbol,
  genericBottomConstructor,
  genericBottomSum,
  genericBoundedEnumConstructor,
  genericBoundedEnumSum,
  genericBoundedEnumSum1,
  genericCouponInfo,
  genericCouponSource,
  genericEnumConstructor,
  genericEnumSum,
  genericEnumSum1,
  genericPromotionIdForSource,
  genericTopConstructor,
  genericUsageData,
  hasFieldCouponInfo,
  hasFieldPromotionIdForSou,
  hasFieldUsageData,
  marketingIsSymbol,
  newtypeCouponInfo_,
  newtypePromotionIdForSour,
  newtypeUsageData_,
  ordCouponSource,
  promotionIdIsSymbol,
  promotionNameIsSymbol,
  showCouponInfo,
  showCouponSource,
  showPromotionIdForSource,
  showUsageData,
  sourceIsSymbol,
  unscrambleDecodeCouponInfo,
  unscrambleDecodeCouponSource,
  unscrambleDecodePromotionIdForSource,
  unscrambleDecodeUsageData,
  usedCouponsIsSymbol
};
